// extracted by mini-css-extract-plugin
export var xs = "375";
export var sm = "576";
export var md = "768";
export var lg = "992";
export var xl = "1200";
export var xxl = "1440";
export var fhd = "1921";
export var partnershipPageLayout = "PartnershipPageLayout-module--partnershipPageLayout--3HbH9";
export var threeIconCardRow = "PartnershipPageLayout-module--threeIconCardRow--Sk729";
export var sixIconCardRow = "PartnershipPageLayout-module--sixIconCardRow--1y227";